import * as d3 from 'd3-selection'
import { nest } from 'd3-collection'
import resultset from './resultset.js';
import * as interactions from '../interactions.js'

export default function (selection) {
  selection.each(function (data) {
    var container = d3.select(this)
                            .selectAll('.select-menu-results')
                            .data(function (d) {
                              return [d]
                            })
      , _container = container.enter()
                              .append('div')
                                .attr('class', 'select-menu-results')
                                .on('mouseleave', function (e, d) {
                                  // When the mouse leaves the menu container, emit change:highlighted without
                                  // a highlighted option, so nothing is highlighted.
                                  d.emit('change:highlighted')
                                })
                                .merge(container)

    var resultsets = _container.selectAll('.select-menu-resultset')
                               .data(function () {
                                 if (data.groupBy) {
                                   return nest().key(function (d) {
                                                  return d[data.groupBy]
                                                })
                                                .entries(data.menuOptions)
                                 } else {
                                   return [{
                                     key: null,
                                     values: nest().entries(data.menuOptions)
                                   }]
                                 }
                               })
      , enter = resultsets.enter()
                          .append('div')
                            .attr('class', 'select-menu-resultset')
      , _resultsets = enter.merge(resultsets)

    resultsets.exit()
              .remove()

    var header = _resultsets.selectAll('.select-menu-resultset-header')
                            .data(function (d) {
                              return data.render.groupHeader ? [d] : []
                            })
    header.enter()
          .append('div')
            .attr('class', 'select-menu-resultset-header')
            .merge(header)
            .attr('data-group', function (d) {
              return d.key
            })
            .html(function (d) {
              return data.render.groupHeader.apply(this, [d.key, d.values])
            })

    header.exit().remove()

    enter.append('ul')
    _resultsets.selectAll('ul')
               .data(function (d) {
                 return [d.values]
               })
               .call(data.render.resultset || resultset, data, _container.node())
  })
}
